import React, {useContext} from "react";
import "./Achievement.scss";
import AchievementCard from "../../components/achievementCard/AchievementCard";
import {achievementSection,brandWorked} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
export default function Achievement() {
  
  if (!achievementSection.display) {
    return null;
  }
  return (
    
    <Fade bottom duration={1000} distance="20px">
      <div className="main" style={{width:"100%",padding:0}} id="achievements">
        <p className="brand-txt-header">
      Some brands I've worked with…
    </p>
        <div className="achievement-main-div">
          <div class="slider-container">
    <div class="slider-track">
      {brandWorked.brandImg.map((brands, i) => {
            return (
                <div class="button-wrapper">
                  <div class="slider-shadow-box"></div>
                  <div class="slider-brand">
                    <img src={brands.brandImg} style={{filter: "brightness(0) invert(1)"}}></img>
                  </div>
                </div>
            );
          })}
          {brandWorked.brandImg.map((brands, i) => {
            return (
                <div class="button-wrapper">
                  <div class="slider-shadow-box"></div>
                  <div class="slider-brand">
                    <img src={brands.brandImg} style={{filter: "brightness(0) invert(1)"}}></img>
                  </div>
                </div>
            );
          })}
      
    </div>
  </div>

        </div>
      </div>
    </Fade>
  );
}
